import Vue from 'vue'
import Vuex from 'vuex'
import config from './modules/config'
import { columns,after_sale } from '@/api/platform.js'
import { userinfo } from '@/api/home.js'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    config,
  },
  state: {
    meau:[],
    slider:[],
    tabs: [],
    sale: 0,
    user: { nickname: 'MOOBY' },
    ossUrl: 'https://moobyyoho.oss-us-west-1.aliyuncs.com/'
  },
  actions: {
    getAftersale: (store) => {
      after_sale().then(res => {
        if(res) {
          console.log(res)
          store.state.sale = res.data
        }
      }).catch(() => {
        store.state.sale = 0
      })
    },
    getColumn: (store) => {
      after_sale().then(res => {
        if(res) {
          store.state.sale = res.data
          columns().then(res => {
            if(res){
              store.state.meau = res.data;
              store.state.meau.forEach(item => {
                if(item.id == 5) {
                  item.sale = store.state.sale
                  item.children.forEach(it => {
                    if(it.id == '40') {
                      it.sale = store.state.sale
                    }
                  })
                }
              })
            }
          }).catch( () => {
            store.state.meau = []
          })
        }
      }).catch(() => {
        store.state.sale = 0
      })
      
    },
    getSlider: (store,data) => {
      store.state.slider = data;
    },
    getUser: (store) => {
      userinfo().then(res => {
          if(res){
            store.state.user = res.data;
          }
      }).catch( () => {
        store.state.meau = []
      })
    },

  },

  mutations: {
    tabAdd: (store, tab) => {
      let bol = true
      store.tabs.forEach(e => {
        if(e.path == tab.path) {
          bol = false
        }
      })
      if(bol && tab.path != '/' && tab.path != '/404' && tab.path.split('/').length < 5) {
        store.tabs.push(tab)
        if(store.tabs.length > 10) {
          store.tabs.splice(0, 1)
        }
      }
      
    },
    tabDel: (store, path) => {
      let index = Number
      store.tabs.forEach( (e, ind) => {
        if(e.path == path) {
            index = ind
        }
      })
      store.tabs.splice(index, 1)
    },
  }

})

export default store;

